import { Columns } from "types";

export const makeSelectQueryFromColumns = (columns: Columns) => columns.join(",");
